import axios from 'axios'
import { Headers } from "../interface"
import { sendDelete, sendGet, sendPost } from 'src/utils/sendApi'

export const filterBayesianDataApi = (params: any, headers: Headers) => {
    return axios.post<any>(
        process.env.REACT_APP_ML_URL + 'filter_data',
        params,
        {
            headers
        }
    )
}


export const getPropertiesExtrapolation = (params: any, headers: Headers) => {
    return axios.get<any>(
        process.env.REACT_APP_ML_URL + 'extrapolation/wo/generate_range_bounds?work_order_id=' + params,
        {
            headers
        }
    )
}

export const predictExperimentBayesianSocket = (payload: string) => {
    return new Promise((resolve, reject) => {      
        const socket = new WebSocket(
            process.env.REACT_APP_ML_WS_URL + 'inverse/predict/ws/bayes/' + payload
        )
        socket.onopen = function () {
            resolve(socket)
        }

        socket.onerror = function (evt) {
            reject(payload)
        }
    })
}


export const getPredictionHistoryList = sendPost('v1/data/bayesian-optimizations/list')

export const getPredictionHistoryDetails = sendPost(`v1/data/bayesian-optimizations/details`)

export const getPredictionHistoryDetailFilter = sendPost(`v1/data/bayesian-optimizations/details/filter`)

export const deletePredictionHistory = sendDelete(`v1/data/bayesian-optimizations/delete`)

export const projectFilterOptions = sendGet(`v1/data/bayesian-optimizations/projects`)

